import { z } from 'zod';

export type UseVacancyChangeActivityFormValues = {
  activityType: 'always' | 'period';
  activeFrom: Date | null;
  activeTo: Date | null;
};

export const UseVacancyChangeActivitySchema = z
  .object({
    activityType: z.enum(['always', 'period'], {
      message: 'Выберите тип активности',
    }),
    activeFrom: z
      .date()
      .nullable()
      .refine(
        data => {
          if (!data) {
            return true;
          }

          const today = new Date().setHours(0, 0, 0, 0);

          const activeFrom = new Date(data).setHours(0, 0, 0, 0);

          return activeFrom >= today;
        },
        {
          message:
            'Дата начала активности должна быть больше или равна текущей дате',
        }
      ),
    activeTo: z.date().nullable(),
  })
  .refine(
    data => {
      if (data.activityType === 'always') {
        return !!data.activeFrom;
      }
      return true;
    },
    {
      message: 'Дата начала активности обязательна',
      path: ['activeFrom'],
    }
  )
  .refine(
    data => {
      if (data.activityType === 'period') {
        return !!data.activeFrom;
      }
      return true;
    },
    {
      message: 'Дата начала обязательна при выборе периода',
      path: ['activeFrom'],
    }
  )
  .refine(
    data => {
      if (data.activityType === 'period') {
        return !!data.activeTo;
      }
      return true;
    },
    {
      message: 'Дата окончания обязательна при выборе периода',
      path: ['activeTo'],
    }
  )
  .refine(
    data => {
      if (data.activityType === 'period' && data.activeFrom && data.activeTo) {
        return data.activeFrom < data.activeTo;
      }
      return true;
    },
    {
      message: 'Дата окончания должна быть больше даты начала',
      path: ['activeTo'],
    }
  );
